import { useParams } from "react-router";
import TransactionForm from "../../components/Transactions/TransactionForm";
import { useFondByIdQuery } from "../../stores/OkOkStore";
import type { Transactions } from "../../types/Transaction";
import { useTrads } from "../../contexts/trads/useTrads";
function TransactionAdd (){
    const params = useParams();

    const { data:fond, error, isLoading } = useFondByIdQuery(params.fondId??"0");
    const transaction:Partial<Transactions>={fond_id:parseInt(params.fondId??"0")};
    const {translate}=useTrads();

    return (



            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>

            ) : fond ? (
                <TransactionForm transactionParam={transaction} />
            ):null
        )

        

}
export default TransactionAdd;